import '../plugins/bootstrap-colorselector.min.js'

export default {
    sytleInputs () {
        $('#colorselector').colorselector()
    },
    errorPop (title, message) {
        $.Notification.notify('error', 'top right', title, message)
    },
    successPop (title, message) {
        $.Notification.notify('success', 'top right', title, message)
    },
    warningPop (title, message) {
        $.Notification.notify('warning', 'top right', title, message)
    },
    blackPop (title, message) {
        $.Notification.notify('black', 'top right', title, message)
    },
    infoPop (title, message) {
        $.Notification.notify('info', 'top right', title, message)
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/core/Helpers.js